import BaseEntity from './BaseEntity'
import createAccount from './Account'

const Props = {
  id: undefined,
  name: undefined,
  avatarImageUrl: undefined,
  dateOfBirth: undefined,
  gender: undefined,
  account: undefined,
  __typename: undefined,
}

class CurrentUser extends BaseEntity {
  constructor(params) {
    super(params)
    this.account = createAccount(params.account || {})
  }

  get isCoach() {
    return this.__typename == 'CurrentCoach'
  }
}

export default function createCurrentUser(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new CurrentUser(attr))
}
